var React = require('react');

function News (props) {
    return React.createElement("svg",props,[React.createElement("path",{"style":{"fill":"#010002"},"d":"M28,7V3H0v22c0,0,0,4,4,4h25c0,0,3-0.062,3-4V7H28z M4,27c-2,0-2-2-2-2V5h24v20\n\t\t\tc0,0.921,0.284,1.559,0.676,2H4z","key":0}),React.createElement("rect",{"x":"4","y":"9","style":{"fill":"#010002"},"width":"20","height":"2","key":1}),React.createElement("rect",{"x":"15","y":"21","style":{"fill":"#010002"},"width":"7","height":"2","key":2}),React.createElement("rect",{"x":"15","y":"17","style":{"fill":"#010002"},"width":"9","height":"2","key":3}),React.createElement("rect",{"x":"15","y":"13","style":{"fill":"#010002"},"width":"9","height":"2","key":4}),React.createElement("rect",{"x":"4","y":"13","style":{"fill":"#010002"},"width":"9","height":"10","key":5})]);
}

News.defaultProps = {"version":"1.1","width":"32px","height":"32px","viewBox":"0 0 32 32"};

module.exports = News;

News.default = News;
